import React, { useEffect, useRef, useState } from 'react';
import Header from "../../../Components/Header/Header.js";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../Components/TopMenu/TopMenu.js';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import { withRFSToken } from '../../../Services/axios.js';
import { faChevronDown, faGear, faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Dropdown, Modal, Button, Tab, Tabs } from 'react-bootstrap';
import { GETULDDETAILS, MVTHDETAILS, GETDAMAGETYPE, UPDATESTATUS, UPDATECONDITION, ULDASSETSGRID, ULDSEARCH, ULDSEARCHDETAILS } from '../../../Utils/conts.js';
import edit from "../../../assets/images/edit.png";
import { faPaperclip, faXmark } from '@fortawesome/free-solid-svg-icons';
import Cargoplane from "../../../assets/images/plane.svg";
import { Link } from 'react-router-dom';
import ImageUpload from '../../../Components/common/ImageUpload.js';
import ActivityComments from '../../../Components/common/ActivityComments.js';
import Trash from '../../../assets/images/trash.png';
import LinkImage from '../../../assets/images/link.png';
import Plantripimg from "../../../assets/images/plan_trip.png";
import { toast } from 'react-toastify';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { applyOffsetToDateTime, CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import ConfModal from '../../../Components/common/ConfModal.js';
const ULDStock = ({ DClick, AddClick, PtClick, PDClick, tripsClick }) => {
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [action, setAction] = useState(null);
    const tabName = localStorage.getItem('grid_tab');
    const [activeTab, setActiveTab] = useState(tabName || 'Active');
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [changeFunction, setchangeFunction] = useState(null);
    const [conditionChange, setConditionChange] = useState('Serviceable');
    const [missingInfo, setMissingInfo] = useState();
    const [damageType, setDamageType] = useState([]);
    const [missingModal, setMissingModal] = useState(false);
    const [selectedData, setSelectedData] = useState();
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const isMounted = useRef(false);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [filterApplied, setFilterApplied] = useState(false);
    const [totalRows, setTotalRows] = useState({});
    const [totalRowsR, setTotalRowsR] = useState(0);
    const [gridSelect, setGridSelect] = useState([]);
    const [editData, setEditData] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [searchItems, setSearchItems] = useState([])

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        localStorage.setItem('grid_tab', tab);
        //const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }

    };

    let checkUlds = [];
    let filterForCheck = false;

    const uldSearch = async () => {
        try {
            const res = await withRFSToken.post(ULDSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // const transformedData = innerData.map((name, index) => ({
                    //     id: index,
                    //     name: name
                    // }));
                    const transformedData = Object.entries(innerData).map(([key, value], index) => ({
                        id: key,
                        name: value
                    }));
                    setSearchItems(transformedData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const addUld = () => {
        localStorage.removeItem('F_EditULD');
        localStorage.setItem('F_AddULD', "uldstock");
        // window.location.href = '/ULDForwarder/AddULD';
        AddClick()
    }

    const handleCancelChange = () => {
        setShowConfirmation(false);
        setAction(null);
    };

    // const handlePlanTrip = () => {
    //     setShowConfirmation(true);
    // };

    const changeStatus = async (selectedIds) => {


    };


    const handleDropdownItemClick = (pos, actn) => {

        const saveAndNavigate = (actn, data) => {
            localStorage.setItem(actn, JSON.stringify(data));
            // localStorage.setItem('tab', 'assets');
            const fnPageUrl = '/ULDControl/ULDFunction';  // Replace with your dynamic path if needed
            window.location.href = fnPageUrl;
        };

        // Check if an actn is already in operation
        const checkStatusAlreadyInOperation = (gridSelect, actn) => {
            return gridSelect.some(item => item.status === actn);
        };

        // Logic for handling 'details' position
        const handleDetailsAction = () => {
            if (['Repair In', 'Repair Out', 'SCM'].includes(actn)) {
                const storageData = { "ULD": [selectedRowData], "Form": {} };
                saveAndNavigate(actn, storageData);
            } else if (actn === 'Lease Out') {
                if (selectedRowData.asset_type === 'Y') {
                    toast.error("ULDs with asset type Owned selected, this action is not possible.");
                } else {
                    const storageData = { "ULD": [selectedRowData], "Form": {} };
                    saveAndNavigate('Lease Out', storageData);
                }
            } else {
                if (actn !== 'Condition') {
                    if (selectedRowData.status === actn) {
                        toast.error('Status already in operation');
                    } else {
                        setAction(actn);
                        setShowConfirmation(true);
                        setchangeFunction(() => changeStatus);
                    }
                } else {
                    setAction(actn);
                    setShowConfirmation(true);
                    fetchDamageType();
                    setchangeFunction(() => changeStatus);
                }
            }
        };

        const missingUld = async (uld) => {
            setMissingModal(true);
            setMissingInfo(uld);
        }

        const fetchBuildup = async () => {
            const uldNumbers = gridSelect && gridSelect.map(num => num.id)
            try {
                const res = await withRFSToken.post('forwarder-action/status-change-uld-stock', { stock_ids: uldNumbers })
                    .then(function (res) {
                        if (res.data.response_code == 200) {

                        }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }


        // Logic for handling 'top' position
        const handleTopAction = () => {
            // const statusTest = gridSelect?.find(st => st.status === 'Missing') || null;
            // console.log('rrr', statusTest);
            // if( actn === 'Build Up')

            if (gridSelect.length > 0) {
                if (['Build Up'].includes(actn)) {
                    if (gridSelect.length > 1) {
                        toast.error('Please select one stock to Operate');
                    } else {
                        if (gridSelect[0].status == 'Build Up') {
                            toast.error('The status is already Build Up');
                        } else {
                            setShowConfirmation(true);
                            setAction(actn);
                        }
                    }
                } else {
                    const statusTest = gridSelect?.some(st => st.status === actn);
                    if (statusTest) {
                        toast.error(`Selected status is already in ${actn}`);
                    } else {
                        setShowConfirmation(true);
                        setAction(actn);
                    }

                }
            } else {
                // if (['Build Up'].includes(actn)) {
                // const storageData = { ULD: [], Form: {} };
                // saveAndNavigate(actn, storageData);
                localStorage.removeItem(actn);
                // window.location.href = '/ULDForwarder/ActionBuildUp';
                // } else {
                toast.error('Please select at least one stock to Operate');
                // }
            }
        };

        // Main conditional logic based on the position (pos)
        if (pos === 'details') {
            handleDetailsAction();
        } else if (pos === 'top') {
            handleTopAction();
        }

    };
    const handleConfirmChange = (actionType) => {
        // deleteRow(gridSelect);
        const uldNumbers = gridSelect.map(item => item.id);
        const checkStatus = gridSelect.map(item => item.status);
        const sendStatus = action == 'On Stock' ? 'onstock' : action == 'Build Up' ? 'buildup' : action == 'Reserved' ? 'reserve' : 'archive';
        CallApi({
            endPoint: 'forwarder-uld-action/update-uld-status',
            payload: { uld_ids: uldNumbers, status: sendStatus },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setShowConfirmation(false);
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
        // try {
        //     const res = await withRFSToken.post('forwarder-action/status-change-uld-stock', { ids: uldNumbers, status: sendStatus });
        //     if (res.data.response_code == 200) {
        //         localStorage.removeItem(action);
        //         toast.success(res.data.response_msg);
        //         // if (action == 'Build Up') {
        //         //     const data = { uld_number: gridSelect[0].uld_number, uld_id: gridSelect[0].uld_id }
        //         //     localStorage.setItem(action, JSON.stringify(data));
        //         //     window.location.href = '/ULDForwarder/ActionBuildUp';
        //         // } else {
        //         gridSelect.forEach(item => {
        //             const selectedRowBoundIndex = item.boundindex;
        //             window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        //         });
        //         window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        //         setShowConfirmation(false);
        //         // }

        //     } else {
        //         toast.error(res.data.response_msg);
        //     }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }

    };

    useEffect(() => {
        if (isMounted.current) return;
        uldSearch();
        setIsLoading(false);
        setGridData({ Active: {} });
        localStorage.removeItem("uld_id");

        isMounted.current = true;
    }, []);


    const fetchDamageType = async () => {
        try {
            const res = await withRFSToken.post(GETDAMAGETYPE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setDamageType(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'created', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'status_name', type: 'string' },
                    { name: 'department_name', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'control_receipt_numb', type: 'string' },
                    { name: 'receiving_airline', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'on_loan', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'sender_handler', type: 'string' },
                    { name: 'luc_out', type: 'string' },

                    { name: 'handler_station_code', type: 'string' },
                    { name: 'handlerOrgId', type: 'string' },
                    { name: 'assigned', type: 'string' },
                    { name: 'receipt_number', type: 'string' },
                    { name: 'receipt_id', type: 'string' },
                ],
                id: `${activeTab}-`,
                // url: `${process.env.REACT_APP_RFS_URL}uld-control/active-uld-stock?tab_type=${tabType}`,
                url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/get-uld-list?tab_name=${tabType}&main_tab=S`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // start filter cursor
                    // const grid = window.$(gridRefs[activeTab].current);
                    // const filterInfo = grid.jqxGrid('getfilterinformation');
                    // const datafield = filterInfo?.[0]?.datafield;

                    // grid.jqxGrid('clearselection');
                    // grid.jqxGrid("updatebounddata", "filter");

                    // setTimeout(() => {
                    //     if (!datafield) return;

                    //     const selector = `input[id^='filterrow0${datafield}']`;
                    //     const input = grid.find(selector)[0];

                    //     if (input) {
                    //         input.focus();

                    //         const val = input.value;
                    //         input.selectionStart = input.selectionEnd = val.length;
                    //     }
                    // }, 50);

                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setTotalRows({ totalUlds: data.activeCount });
                    setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                },
                { text: 'Created', filtertype: 'range', datafield: 'created', width: '8%', cellclassname: '', },
                { text: 'ULD Number', filtertype: 'input', datafield: 'uld_number', width: '10%', cellclassname: '', },
                {
                    text: 'Status', filtertype: 'checkedlist', filterable: true,
                    filteritems: [
                        { label: 'On Stock', value: 'On Stock' },
                        { label: 'Reserved', value: 'Reserved' },
                        { label: 'Build Up', value: 'Build Up' },
                        { label: 'On Trip', value: 'On Trip' },
                    ],
                    datafield: 'status_name', width: '8%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                        if (cellValue.status_name === 'Build Up') {
                            return '<div class="jqx-grid-cell-left-align fw_progess">' + cellValue.status_name + '</div>';
                        } else if (cellValue.status_name === 'On Stock') {
                            return '<div class="jqx-grid-cell-left-align fw_onstock">' + cellValue.status_name + '</div>';
                        } else if (cellValue.status_name === 'On Trip') {
                            return '<div class="jqx-grid-cell-left-align fw_planed">' + cellValue.status_name + '</div>';
                        } else if (cellValue.status_name === 'Reserved') {
                            return '<div class="jqx-grid-cell-left-align fw_reserve">' + cellValue.status_name + '</div>';
                        } else {
                            return defaulthtml;
                        }
                    },
                },
                { text: 'Department Name', filtertype: 'textbox', datafield: 'department_name', width: '8%', cellclassname: '', },
                { text: 'Type Code', filtertype: 'input', datafield: 'type_code', width: '5%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'input', datafield: 'serial_number', width: '6%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'input', datafield: 'owner_code', width: '5%', cellclassname: '', },
                {
                    text: 'Condition Code', filtertype: 'textbox', datafield: 'condition_code', width: '6%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.condition_code === 'SER') {
                            return '<div class="jqx-grid-cell-left-align set_dock ">Servicable</div>';
                        } else if (rowdata.condition_code === 'DAM') {
                            return '<div class="jqx-grid-cell-left-align set_dock">Damaged</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align set_dock">Discarded</div>';
                        }
                    },
                },
                // { text: 'Receipt Number', filtertype: 'textbox', datafield: 'control_receipt_numb', width: '8%', cellclassname: '', },
                // Reference From VehicleView.js
                {
                    text: 'Receipt Number',
                    width: '10%',
                    filtertype: 'textbox',
                    datafield: 'receipt_number',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                        let receiptNumber = rowData.receipt_number || '';
                        let imageHtml = receiptNumber ? `<img src="${LinkImage}" alt="Link" style="width: 15px;margin-right: 7px;" />` : '';
                        return `<div class="receipt-number-cell jqx-grid-cell-left-align" data-receipt="${receiptNumber}" style="margin-top:13px;">
                                    ${imageHtml} ${receiptNumber}
                                </div>`;
                    }
                },
                {
                    text: 'Airline', filtertype: 'textbox', datafield: 'receiving_airline', width: '10%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                        if (value.airline_name == null) {
                            return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"> </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.airline_name + '</div>';
                        }
                    },
                },
                { text: 'Handler Name', filtertype: 'textbox', datafield: 'sender_handler', width: '8%', cellclassname: '', },
                { text: 'On Loan', filtertype: 'textbox', filtermode: 'range', datafield: 'on_loan', width: '6%', cellclassname: '', },
                { text: 'Airway Bill', filtertype: 'textbox', filtermode: 'range', datafield: 'airway_bill', width: '8%', cellclassname: '', },
            ];
            if (activeTab === 'Archived') {
                columns = columns.filter(col => col.datafield !== 'status_name');
            }
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                },
                ready: function () {
                    localStorgeFilter();
                },
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        localStorage.setItem('F_EditULD', rowData.id);
                        localStorage.setItem('grid_tab', activeTab);
                        localStorage.setItem('F_AddULD', "uldstock");
                        AddClick()
                        // window.location.href = '/ULDForwarder/AddULD'
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

                // localStorage.setItem('uld_id', rowData.uld_id);
                // localStorage.setItem('F_AddULD', "uldStock");
                // window.location.href='/ULDForwarder/AddULD'
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                // setSelectedData(args);
                if (event.args.columnindex > 1) {
                    loadDetails(args.id, args.assigned);
                    // if (gridSelect) {
                    //     gridSelect.forEach(item => {
                    //         const selectedRowBoundIndex = item.boundindex;
                    //         window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    //     });
                    // }

                    // setSelectedRowData(args)
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.receipt-number-cell', function () {
                // const receiptNumber = window.$(this).data('receipt');

                // const filter = [{
                //     datafield: "control_receipt_numb",
                //     filters: [{
                //         condition: "CONTAINS",
                //         operator: 1,
                //         value: receiptNumber
                //     }]
                // }];
                // localStorage.setItem("ptFilter", JSON.stringify(filter));
                // tripsClick()
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    // console.log('Global Index:', rowData); 
                    if (rowData) {
                        const localData = { id: rowData.receipt_id, source: 'activeTrips' }
                        localStorage.setItem('Fdetails', JSON.stringify(localData));
                        PDClick()
                    } else {
                        console.error('No data found for the given row index.');
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on("celldoubleclick", function (event) {
                const args = event.args;
                const dataField = args.datafield;
                const rowIndex = args.rowindex;
                const cellValue = args.value;
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // console.log("Column:", dataField);
                // console.log("Cell value:", cellValue);
                // console.log("Full row:", rowData);
                // console.log(cellValue);
                navigator.clipboard.writeText(cellValue)
                    .then(() => {
                        toast.success("Copied to clipboard: " + cellValue);
                    })
                    .catch(err => {
                        //console.error("Failed to copy: ", err);
                    });
            });
        }
    }, [gridData]);
    function localStorgeFilter() {
        let savedFilters = localStorage.getItem('usFilter');
        if (savedFilters) {
            savedFilters = JSON.parse(localStorage.getItem('usFilter'));
            savedFilters.forEach(element => {
                const filterValue = element.filters[0].value;
                if (filterValue !== null && filterValue !== undefined) {
                    const filterGroup = new window.$.jqx.filter();
                    const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
                    const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
                    filterGroup.addfilter(1, filter);
                    window.$(gridRefs[activeTab].current).jqxGrid("addfilter", 'uld_number', filterGroup);
                }
            });
            window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
            localStorage.removeItem('usFilter');
        }
    };
    const loadDetails = (uldNumber, assd) => {
        setDisLoading(true);
        CallApi({
            endPoint: 'forwarder-uld-control/get-uld-details',
            payload: { uld_id: uldNumber },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setSelectedRowData(innerData);
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters', true);
    };

    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);


    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const fetchDataGrid = async (pageNumber, psize) => {
        const page_number = pageNumber ? pageNumber : 1;
        const pageSize = psize ? psize : 20;
        setIsLoading(true);
        const tabName = activeTab == 'Active' ? 'A' : 'R';
        try {
            const res = await withRFSToken.post(ULDASSETSGRID, { page: page_number, type: tabName, page_size: pageSize })
            // .then(function (res) {
            if (res.data.response_code == 200) {
                setIsLoading(false);
                const innerData = res.data.response_data.ulds;
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData({ Active: innerData });
                setTotalRows({
                    pageSize: res.data.response_data.page_size,
                    currPage: res.data.response_data.current_page,
                    lastPage: res.data.response_data.last_page,
                    totalUlds: res.data.response_data.total_ulds
                });
                setTotalRowsR({
                    totalUlds: res.data.response_data.archive_count
                });
                // window.$(gridRefs[activeTab].current).jqxGrid('pagesize', res.data.response_data.page_size);
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };

    const conditionModalClose = () => {
        setShowConfirmation(false);
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => ({
                ...item,
                files: [],
                base64Files: []
            }))
        );
        setFiles([])
        setBase64Files([]);
    }

    const handleRemove = (indexToRemove) => {
        // const idToRemove = gridSelect[indexToRemove];
        // const selectedRowBoundIndex = idToRemove.boundindex;
        // window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // // setGridSelect(prevGridSelect => prevGridSelect.filter((id) => id.uid !== indexToRemove));
        // const newGridSelect = [...gridSelect.slice(0, indexToRemove), ...gridSelect.slice(indexToRemove + 1)];
        // setGridSelect(newGridSelect);
        setGridSelect(prev => prev.filter(row => row.uld_number !== indexToRemove));
        const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        rows.forEach((element, index) => {
            if (element.uld_number == indexToRemove) {
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', index);
            }
        });

    };

    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            const checkStatus = gridSelect.some(st => st.status_name === 'On Trip');
            if (activeTab == 'Active' && checkStatus) { toast.error('Can not send ULD to archive with the status On Trip'); return; }
            // console.log('checkStatus', checkStatus);

            setModalConf(true);
        }
    };
    const confirmMoveToActArc = () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'archived' : 'active';
        const uldNumbers = gridSelect && gridSelect.map(item => item.id);
        CallApi({
            endPoint: 'forwarder-uld-action/update-uld-activity-status',
            payload: { uld_ids: uldNumbers, status: sendAction },
            onSuccess: (data) => {
                const innerData = data.data;
                if (innerData.response_code === 200) {
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    toast.success(data.data.response_msg);
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                }
                setModalConf(false)
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const confModalClose = () => {
        setModalConf(false);
    }

    const handlePlanTrip = () => {
        localStorage.removeItem('plan_trip');
        localStorage.removeItem('EditFULD');

        if (gridSelect.length > 0) {
            const isSameHandler = gridSelect.every(item => item.luc_out === gridSelect[0].luc_out);
            console.log('isSameHandler', isSameHandler);


            if (isSameHandler) {
                // const hasAssigned = gridSelect.some(item => item.assigned === 'Y');
                // if (hasAssigned) {
                //     toast.error('One or more selected ULDs are already assigned!');
                //     return;
                // }

                const filteredGridSelect = gridSelect.map(
                    ({ uld_number, type_code, owner_code, serial_number, condition_code, uld_id, assigned, handlerOrgId }) => ({
                        uld_number,
                        type_code,
                        owner_code,
                        serial_number,
                        condition_code,
                        uld_id,
                        assigned,
                        handlerOrgId
                    })
                );

                const lData = {
                    station_name: gridSelect[0].origin ?? gridSelect[0].handler_station_code,
                    handler_id: gridSelect[0].luc_out,
                    ulds: filteredGridSelect
                };

                localStorage.setItem('plan_trip', JSON.stringify(lData));
                // localStorage.setItem('back_plan', 'US');
                // window.location.href = '/ULDForwarder/PlanTrip';
                PtClick()
            } else {
                toast.error('All selected ULDs must have the same Origin Company!');
            }
        } else {
            // localStorage.setItem('back_plan', 'US');
            // window.location.href = '/ULDForwarder/PlanTrip';
            PtClick()
        }
    };

    const handleDetails = () => {
        // const localData = { id: selectedRowData.uld_id, backUrl: '/ULDForwarder/ULDStock' }
        const localData = { id: selectedRowData.id, source: 'uldStock' }
        // localStorage.setItem('source_page', 'uldStock');
        localStorage.setItem('Fdetails', JSON.stringify(localData));
        // window.location.href = '/ULDForwarder/Details';
        DClick()
    }

    const handleOnSelect = async (item) => {
        const localData = { id: item.id, backUrl: '/ULDForwarder/ULDStock' }
        localStorage.setItem('source_page', 'uldStock');
        localStorage.setItem('Fdetails', JSON.stringify(localData));
        window.location.href = '/ULDForwarder/Details';
        // the item selected
        // console.log(item)
        // try {
        //     const res = await withRFSToken.post('uld-control/planning-stock-details', { uld_number: item.id, assigned: "N" });
        //     if (res.data.response_code == 200) {
        //         // const localData = { id: selectedRowData.uld_id, backUrl: '/ULDForwarder/ULDStock' }
        //         // localStorage.setItem('source_page', 'uldStock');
        //         // localStorage.setItem('Fdetails', JSON.stringify(localData));
        //         // window.location.href = '/ULDForwarder/Details';
        //     }

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    const statusClass = {
        'On Stock': 'fw_onstock',
        'Build Up': 'fw_progess',
        'Closed': 'fw_reserve',
        'On Trip': 'fw_planed'
    }


    return (
        <>
            {/* <div className="">
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='FORWARDER' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-end mb-3 order_search'>
                                        <div className='search'>
                                            <div className="form-group has-search"> */}
            {/* <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                            <input type="text" className="form-control" placeholder="Search" /> */}
            {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSelect={handleOnSelect}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="lcontent"> */}
            {modalConf &&
                <ConfModal
                    header={`Selected ${gridSelect.length > 1 ? "Row's" : 'Row'} will move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}
                    subHeader={`Are you sure you want to move ${gridSelect.length > 1 ? "Row's" : 'Row'} to ${activeTab == 'Active' ? 'Archive' : 'Active'}?`}
                    modalConf={confirmMoveToActArc}
                    closeModal={confModalClose}
                    primaryBtn={'Yes'}
                    secondaryBtn={'No'}
                />
            }
            <div className="mb-0 nestedtabs rounded">
                <div className='d-flex justify-content-between'>
                    <div className='d-flex'>
                        <div className='me-2'>
                            <button className="addtruck" variant="primary" onClick={addUld}>
                                <span> <FontAwesomeIcon icon={faPlus} /> Add ULD</span>
                            </button>
                        </div>
                        <div>
                            <button className="plan_trip" variant="plan_trip" onClick={handlePlanTrip} >
                                <span className='flex_center'> <img src={Plantripimg} />  Plan Trip</span>
                            </button>
                        </div>
                        <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Reserved')}> Reserved</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'On Stock')}> On Stock</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Build Up')}> Build Up</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <span className="selected">
                            Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                    </div>
                    <div className='d-flex'>
                        <div className='ulddown'>
                            {activeTab === 'Active' && <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>}
                            {activeTab === 'Archived' && <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>}
                        </div>
                    </div>

                </div>

            </div>

            <div className='maindiv'>
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp;
                                <span className={statusClass[selectedRowData.status_name]
                                    // selectedRowData.status_name == 'On Stock' ? 'fw_onstock' : selectedRowData.status_name == 'Build Up' ? 'fw_progess' : selectedRowData.status_name == 'Closed' ? 'fw-reserved-bg' : 'fw_planed'
                                }>
                                    {selectedRowData.status_name}
                                </span>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                <div className='viwall'>
                                    <Link to='#' onClick={handleDetails}>View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className='update_info'>
                            <div className='d-flex justify-content-between align-items-center MB-2'>
                                <h4>ULD Details</h4>
                            </div>
                            <ul>
                                <li>
                                    <span>Create Date :</span>
                                    {/* <span>{selectedRowData?.createdate.slice(0, 10) + ' ' + selectedRowData?.createdate.slice(11, 16)}</span> */}
                                    <span>{applyOffsetToDateTime(selectedRowData?.createdate, 'H')}</span>
                                </li>
                                <li>
                                    <span>Recepit No:</span>
                                    <span>{selectedRowData?.trucking_uld_receipt_info?.control_receipt_numb}</span>
                                </li>
                            </ul>
                        </div>
                        {/* <div className='grid_details'>
                            {selectedRowData?.uld_number && (
                                <h3 className="my-3">ULD Number: {selectedRowData.uld_number}</h3>
                            )}
                            {selectedData?.control_receipt_numb && (
                                <h3 className="mb-0">Receipt Number: {selectedData.control_receipt_numb}</h3>
                            )}
                        </div> */}
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={'forwarder_uld'}
                            attachable_id={selectedRowData.id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.id)}
                        />
                        <ActivityComments
                            commentable_type={'forwarder_uld'}
                            commentable_id={selectedRowData.id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.id)}
                        />
                    </div>
                )}
            </div>
            {/* </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
            <Modal className='addfrom in_oparation' show={showConfirmation} onHide={() => conditionModalClose()} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{action}</Modal.Title>
                    <p>The status of selected ULDs will change to {action}</p>

                </Modal.Header>
                <Modal.Body>
                    <>
                        <div className='d-flex flex-wrap inop opara_w'>
                            {selectedRowData ? (
                                <div className='inbox'><span>{selectedRowData.uld_number}</span></div>
                            ) : (
                                <>{gridSelect && gridSelect.map((num, index) => (

                                    <div key={index} className='inbox'>
                                        <span>{num.uld_number}</span>
                                        <img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} />
                                    </div>
                                ))}
                                </>
                            )}
                        </div>
                    </>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={() => handleConfirmChange(action)}>
                        {['Reserved', 'On Stock', 'Build Up'].includes(action) ? 'Update Status ' + action : 'Update Status'}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Selected {gridSelect.length > 1 ? "Row's" : 'Row'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                    <p>Are you sure you want to move {gridSelect.length > 1 ? "Row's" : 'Row'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal> */}


            {/* </div>
            </div> */}
        </>

    )
}

export default ULDStock